import { ReactNode } from "react";

interface PublicSubPageProps {
  title: string;
  description?: string;
  children?: ReactNode;
}

const PublicSubPage = ({
  title,
  description,
  children,
}: PublicSubPageProps) => (
  <>
    <section className="psite-page-hero">
      <div className="psite-page-hero__inner">
        <h1>{title}</h1>
        {description && <p>{description}</p>}
      </div>
    </section>

    <section className="psite-section">
      <div className="psite-section__inner">
        {children ?? <p className="psite-section__empty">Content coming soon.</p>}
      </div>
    </section>
  </>
);

export default PublicSubPage;